// ── Auto-travel system types (Round 9 Phase A) ──
//
// Earned auto-travel: ley-line graph, attunement, travel state machine.
// Design ref: docs/design/earned-fast-travel.md
// Plan ref: docs/pivot-overnight-plan-9.md §2 Phase A
// ── Wire protocol constants ──────────────────────────────────────────
/** Client → server: request to start auto-travel. */
export const MSG_AUTO_TRAVEL_REQUEST = 'auto_travel_request';
/** Client → server: cancel auto-travel. */
export const MSG_AUTO_TRAVEL_CANCEL = 'auto_travel_cancel';
/** Server → client: auto-travel state update. */
export const MSG_AUTO_TRAVEL_STATE = 'auto_travel_state';
/** Server → client: available auto-travel destinations. */
export const MSG_AUTO_TRAVEL_DESTINATIONS = 'auto_travel_destinations';
/** Client → server: request attunement at current position. */
export const MSG_ATTUNEMENT_REQUEST = 'attunement_request';
/** Server → client: attunement result. */
export const MSG_ATTUNEMENT_RESULT = 'attunement_result';
// ── Constants ────────────────────────────────────────────────────────
/** Restoration percentage threshold for ley-line activation. */
export const LEY_LINE_ACTIVATION_THRESHOLD_PCT = 25;
/** Preparation time before auto-travel begins (ms). */
export const AUTO_TRAVEL_PREPARE_MS = 5_000;
/** Movement speed during auto-travel (cart pixels per second). */
export const AUTO_TRAVEL_SPEED_PX_S = 160;
/** Ley-dust cost per hop. */
export const LEY_DUST_COST_PER_HOP = 1;
/** Range (cart pixels) to be considered "at" a village hearth for attunement. */
export const HEARTH_ATTUNEMENT_RANGE_PX = 5 * 32; // 5 tiles
/** Attunement ritual channel time for village hearths (ms). */
export const HEARTH_ATTUNEMENT_CHANNEL_MS = 10_000;
/** Ley-dust cost for village hearth attunement. */
export const HEARTH_ATTUNEMENT_DUST_COST = 1;
/** Range (cart pixels) to be considered "at" an expedition door for attunement. */
export const DOOR_ATTUNEMENT_RANGE_PX = 5 * 32;
/** Attunement ritual channel time for expedition doors (ms). */
export const DOOR_ATTUNEMENT_CHANNEL_MS = 60_000;
/** Ley-dust cost for expedition door attunement. */
export const DOOR_ATTUNEMENT_DUST_COST = 2;
/** Maximum ley-dust stack size. */
export const LEY_DUST_MAX_STACK = 99;
//# sourceMappingURL=autoTravel.js.map